export default __webpack_public_path__ + "static/media/trr-drink-coffeecocktail-oldfashioned.50327c3d.png";